const getSearchUrl = (parentUrl) => {
	if (parentUrl.includes('localhost:3000')) {
		return 'http://localhost:5005';
	}

	if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
		return 'https://staging-search.chekkit.io';
	}

	return 'https://search.chekkit.io';
};

export default getSearchUrl;
